<script>
  import UserOrInvitationAction from './UserOrInvitationAction.svelte';
  import UserProfilePicture from './UserProfilePicture.svelte';
  import {orderBy} from 'lodash';

  export let data, sortBy, showDeactivatedUsers, isAdmin = false;

  let userAccounts = [];

  $: userAccounts = sortAndFilter(data, sortBy, showDeactivatedUsers);

  function sortAndFilter(d, sort, showDeactivated) {
    return orderBy(
      showDeactivated? d: d.filter(u => u.status !== 'UNVERIFIED'),
      ['currentUser', sort.key],
      ['asc', sort.order]
    );
  }

</script>

{#each userAccounts as userAccount}
  <div class="Item">
    <UserProfilePicture picture="{userAccount.profilePicture}" name="{userAccount.fullName}" />

    <div class="Details">
      <div class="Name">
        { userAccount.fullName }
      </div>

      <div class="Status"
           class:StatusActive="{ userAccount.status === 'ACTIVE' }"
           class:RoleAdmin="{ userAccount.isAdmin }"
           data-icon-before="account_circle"
      >
        <span class="Type">{userAccount.type}</span>
        <span class="Dot">&nbsp;&middot;&nbsp;</span>

        {#if userAccount.managedAccountsLength}
          <span>Managing <b>{ userAccount.managedAccountsLength } Compan{userAccount.managedAccountsLength === 1? 'y': 'ies'}</b></span>
        {:else}
          <span class="Unassigned">Unassigned</span>
        {/if}

        {#if userAccount.status === 'UNVERIFIED'}
          <span class="Dot">&nbsp;&middot;&nbsp;</span>
          <span class="StatusValue" data-icon-before="access_time">Account Deactivated</span>
        {:else if userAccount.status === 'INVITED'}
          <span class="Dot">&nbsp;&middot;&nbsp;</span>
          <span class="StatusValue" data-icon-before="access_time">Pending Acceptance</span>
        {/if}
      </div>

      <div class="Contact">
        {#if userAccount.emailAddress}<span>{ userAccount.emailAddress }</span>{/if}
        {#if userAccount.emailAddress && userAccount.phone}<span class="Dot">&nbsp;&middot;&nbsp;</span>{/if}
        {#if userAccount.phone}<span>{ userAccount.phone }</span>{/if}
      </div>
    </div>

    <div class="Actions">
      <UserOrInvitationAction {userAccount} {isAdmin} />
    </div>
  </div>
{/each}

<style lang="stylus">
  .Item {
    display: flex;
    align-items: center;
    gap: 10px;

    padding 0 20px;
    border-bottom: 1px solid #ECEFF1;
    height: 100px;
    box-sizing border-box;
    color: #37474f;
  }

  .Details {
    flex: 1 1 100%;
    font-size: 12px;
    color: #8a999f;

    .Name {
      font-size 16px;
      line-height: 22px;
      color: #37474f;
    }

    .Status {
      align-items: center;
      line-height: 22px;

      &:before {
        margin-right 5px;
        font-size: 18px;
        color: #8a999f;
      }

      &.StatusActive:before {
        color: #00b8aa;
      }

      &.StatusActive.RoleAdmin:before {
        color #f79423;
      }
    }

    .Contact {
      line-height: 14px;
      display: flex;
      align-items: center;
    }

    .Unassigned {
      color: #f25b26;
      font-size 13px;
    }

    .StatusValue:before {
      color: #8a999f;
      font-size 18px;
      margin-right 5px;
    }
  }

  .Actions {
    flex: 0 0 100px;
  }

  .Dot {
    font-size 15px;
    font-weight bolder;
  }

  .Type {
    text-transform: uppercase;
  }

</style>
